import React from "react";
import { Button, Col, Drawer, Modal, Typography, Upload, message } from "antd";

import "./SellerConfirmationModal.css";
import { ReactComponent as DeliveryIcon } from "../../../../../../assets/icons/delivery-qwik-icon.svg";
import { ReactComponent as VehicleAlertIcon } from "../../../../../../assets/icons/Truckicon.svg";
import { ReactComponent as CameraIcon } from "../../../../../../assets/icons/camera.svg";
const { Text } = Typography;
const SellerConfirmationModal = ({
  title,
  subId,
  isModalOpen,
  setIsModalOpen,
  handleOk,
  updateOrderStatusLoading,
  data,
  pickupTime,
  selectedVehicles,
  shippingImages,
  setShippingImages,
}) => {
  const getIsMobileView = () =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false;
  const [isMobileView, setIsMobileView] = React.useState(getIsMobileView);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobileView(getIsMobileView());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCancel = () => {
    setIsModalOpen(false);
    setShippingImages([]);
  };
  const isOrderShipped = title === "Order Shipped";
  // const selectedVehicle = selectedVehicles?.find(
  //   (vehicle) => vehicle?.vechicle_type_Id !== "SELECT VEHICLE"
  // );
  const allowedImageExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".svg",
    ".webp",
    ".bmp",
    ".gif",
  ];
  const handleBeforeUpload = (file) => {
    const fileName = String(file?.name || "").toLowerCase();
    const hasValidExtension = allowedImageExtensions.some((ext) =>
      fileName.endsWith(ext)
    );
    const isImageMime = String(file?.type || "").startsWith("image/");
    if (!isImageMime || !hasValidExtension) {
      message.error(
        "Only image files are allowed (.jpg, .jpeg, .png, .svg, .webp, .bmp, .gif)."
      );
      return Upload.LIST_IGNORE;
    }
    if ((shippingImages?.length || 0) >= 5) {
      message.error("Maximum 5 images can be uploaded.");
      return Upload.LIST_IGNORE;
    }
    return false;
  };
  const handleAddShippingImages = ({ fileList }) => {
    const existing = shippingImages || [];
    const merged = [...existing];
    fileList.forEach((file) => {
      if (!merged.some((item) => item.uid === file.uid)) {
        merged.push(file);
      }
    });
    setShippingImages(merged.slice(0, 5));
  };
  const handleShippingImageChange = ({ fileList }) => {
    setShippingImages(fileList.slice(0, 5));
  };

  const modalTitle = isOrderShipped ? (
    <Text className="seller-confirm-shipping-title">Shipping details</Text>
  ) : (
    <Col
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Text style={{ fontWeight: 500, fontSize: "22px" }}>{title}</Text>
    </Col>
  );

  const modalFooter = (
    <Col
      className={isMobileView ? "seller-confirm-mobile-footer" : ""}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "12px 24px 12px 24px",
      }}
    >
      <Button
        onClick={handleCancel}
        style={{
          height: "48px",
          fontWeight: 500,
          fontSize: "14px",
          maxWidth: "120px",
          width: "100%",
        }}
      >
        CANCEL
      </Button>
      <Button
        style={{
          height: "48px",
          // maxWidth: "120px",
          width: "100%",
          fontWeight: 500,
          fontSize: "14px",
          border: "none",
          color: "white",
          backgroundColor: "#015fe5",
        }}
        onClick={handleOk}
        loading={updateOrderStatusLoading}
      >
        {isOrderShipped ? "SHIPPED (Generate MOB invoice)" : "CONFIRM"}
      </Button>
    </Col>
  );

  const modalBody = (
    <>
      {isOrderShipped ? (
        <Col className="seller-confirm-shipping-content">
          <Col className="section-deliverychallan border-radius-16">
            <div className="assigned-container">
              <div className="delivery-challan-left">
                <div className="delivery-challan-icon">
                  <DeliveryIcon />
                </div>
                <p
                  className="detail-heading mb-0 mt-0 delivery-challan-text"
                  style={{ fontWeight: 400 }}
                >
                  Please share only the{" "}
                  <strong>MOB Delivery Challan and Invoice</strong> with the
                  driver at the time of dispatch.
                </p>
              </div>
            </div>
          </Col>

          <Col className="empty-div"></Col>
          <Col className="seller-confirm-upload-section">
            <Text className="seller-confirm-upload-title">
              Upload picture after loading
            </Text>
            <Text className="seller-confirm-upload-subtitle">
              Images helps us understand about the product condition
            </Text>
            <Upload
              multiple
              showUploadList={false}
              accept=".jpg,.jpeg,.png,.svg,.webp,.bmp,.gif,image/*"
              beforeUpload={handleBeforeUpload}
              onChange={handleAddShippingImages}
            >
              <Button
                className="seller-confirm-upload-btn"
                icon={<CameraIcon />}
                disabled={(shippingImages?.length || 0) >= 5}
              >
                Add Image
              </Button>
            </Upload>
            <Upload
              listType="picture-card"
              className="seller-confirm-upload-list"
              fileList={shippingImages}
              onChange={handleShippingImageChange}
              showUploadList={{
                showPreviewIcon: false,
              }}
            />
            {shippingImages?.length > 0 && (
              <Text className="seller-confirm-upload-count">
                {`${shippingImages.length}/5 images selected`}
              </Text>
            )}
            <Col className="seller-confirm-upload-note">
              <VehicleAlertIcon />
              <Text className="seller-confirm-upload-note-text">
                Please make sure that the products and the vehicle number is
                visible
              </Text>
            </Col>
          </Col>
        </Col>
      ) : (
        <Col
          style={{
            padding: "24px 24px 24px 24px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Text
            className="font-big-bold"
            style={{ fontWeight: 500, fontSize: "20px" }}
          >{`Are you sure to change status to '${title}'`}</Text>
          <Text style={{ fontWeight: 500, fontSize: "20px" }}>{subId}</Text>
        </Col>
      )}
    </>
  );

  return (
    <>
      {isMobileView ? (
        <Drawer
          className="seller-confirm-mobile-drawer"
          wrapClassName="seller-confirm-mobile-drawer-wrap"
          placement="bottom"
          height="86vh"
          contentWrapperStyle={{
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            overflow: "hidden",
          }}
          title={modalTitle}
          open={isModalOpen}
          onClose={handleCancel}
          bodyStyle={{ padding: 0 }}
        >
          <div className="seller-confirm-drawer-body">
            <div className="seller-confirm-drawer-scroll">{modalBody}</div>
            {modalFooter}
          </div>
        </Drawer>
      ) : (
        <Modal
          className="confirm-modal"
          title={modalTitle}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[modalFooter]}
        >
          {modalBody}
        </Modal>
      )}
    </>
  );
};
export default SellerConfirmationModal;
